import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { useQuery } from '../../../../../hooks/UseQuery';
import THeadSetup from '../../componentSetup/create/TheadSetup';
import TbodySetup from '../../componentSetup/create/TbodySetup';
import TfootSetup from '../../componentSetup/create/TfootSetup';
interface IProps {
  moduleData: any;
  isView: boolean;
  operation: string[];
  getProcess: any;
}

const TController = ({ moduleData, isView, operation, getProcess }: IProps) => {
  const documentType = useQuery('documentType') || '';
  return (
    <Box>
      <RenderTable>
        {documentType === 'setup' ? (
          <THeadSetup
            {...{
              moduleData,
              getProcess,
              isView,
              operation,
            }}
          />
        ) : (
          <THead
            {...{
              moduleData,
              getProcess,
              isView,
              operation,
            }}
          />
        )}
        {documentType === 'setup' ? (
          <TbodySetup
            {...{
              moduleData,
              isView,
            }}
          />
        ) : (
          <TBody
            {...{
              moduleData,
              isView,
            }}
          />
        )}

        {documentType === 'setup' ? (
          <TfootSetup
            {...{
              moduleData,
              isView,
            }}
          />
        ) : (
          <TFoot
            {...{
              moduleData,
              isView,
            }}
          />
        )}
      </RenderTable>
    </Box>
  );
};

export default TController;
